import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaPalette,
  FaBullhorn,
  FaChartLine,
} from "react-icons/fa";
import "./Services.css";

export default function Services() {
  const [activeIndex, setActiveIndex] = useState(null);

  const services = [
    {
      title: "Web Development",
      short: "Modern, scalable web applications.",
      full: "We build fast, secure, and scalable web applications using modern frameworks and best practices. Our solutions are optimized for performance, SEO, and long-term growth.",
      icon: <FaLaptopCode />,
    },
    {
      title: "Mobile Apps",
      short: "High-performance Android & iOS apps.",
      full: "We design and develop native and cross-platform mobile applications with seamless user experiences, robust performance, and scalable architecture.",
      icon: <FaMobileAlt />,
    },
    {
      title: "Cloud Solutions",
      short: "Secure & scalable cloud systems.",
      full: "Our cloud services include migration, deployment, and optimization on AWS, Azure, and GCP, ensuring security, scalability, and cost efficiency.",
      icon: <FaCloud />,
    },
    {
      title: "UI/UX Design",
      short: "Human-centered product design.",
      full: "We create intuitive, engaging, and accessible user experiences backed by research, wireframing, prototyping, and usability testing.",
      icon: <FaPalette />,
    },
    {
      title: "Digital Marketing",
      short: "Data-driven growth strategies.",
      full: "From SEO and paid campaigns to content marketing and analytics, we help businesses increase visibility, engagement, and conversions.",
      icon: <FaBullhorn />,
    },
    {
      title: "IT Consulting",
      short: "Expert guidance for business growth.",
      full: "Our consulting services help you choose the right technologies, improve processes, and build scalable IT strategies aligned with your business goals.",
      icon: <FaChartLine />,
    },
  ];

  const toggleService = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="services-page">

      {/* Hero */}
      <section className="services-hero">
        <h1>Our Services</h1>
        <p>
          Click on a service to learn more about how we can help your business grow.
        </p>
      </section>

      {/* Services */}
      <section className="services-section">
        <div className="services-container">
          <div className="services-grid">
            {services.map((service, i) => {
              const isActive = activeIndex === i;

              return (
                <motion.div
                  key={i}
                  layout
                  onClick={() => toggleService(i)}
                  className={`service-card ${isActive ? "active" : ""}`}
                >
                  <div className="service-icon-wrapper">
                    {service.icon}
                  </div>

                  <h3>{service.title}</h3>
                  <p className="service-short">{service.short}</p>

                  <AnimatePresence>
                    {isActive && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.4 }}
                        className="service-full"
                      >
                        <p>{service.full}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  <span className="service-toggle">
                    {isActive ? "Show Less" : "Read More"}
                  </span>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

    </div>
  );
}
